<template>
  <div>
    <div
      class="animate-navbar fixed top-0 z-50 hidden w-full border-b px-14 py-4 transition duration-150 ease-out lg:block"
      :class="{ 'bg-navbar': scroll }"
    >
      <div class="flex items-center justify-between">
        <router-link to="/dashboard">
          <img src="@/assets/img/logo/goparity.svg" alt="" class="" />
        </router-link>
        <div class="flex items-center">
          <router-link
            v-for="el in navigationLinksDesktop"
            :id="'gp-link-' + el.name.toLowerCase().replace(/\s+/g, '') + '-1'"
            :key="el.name"
            :to="{
              name: isPromoter && el.promoter_link ? el.promoter_link : el.link,
            }"
            class="mr-10 text-sm"
            :class="
              (el.matches && el.matches.includes(currentRoute)) || el.link === currentRoute
                ? 'font-semibold text-grey-2'
                : 'nav-link text-grey-4'
            "
          >
            {{ isPromoter && el.promoter_name ? el.promoter_name : el.name }}
          </router-link>
          <div
            id="navbar-drop"
            class="relative h-8 w-8 cursor-pointer rounded-xl border-2"
            @click="opened = !opened"
          >
            <div
              v-if="profile && profile.name && profile.surname"
              id="navbar-drop-text"
              class="no-highlight absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-13 font-bold uppercase text-grey-4"
            >
              {{ initials }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-clickoutside="opened"
        class="fixed right-14 top-24 scale-0 transform rounded-3xl bg-white pt-6 text-left transition-all"
        :class="{ 'scale-100': opened }"
      >
        <span v-for="el in $tm('navigation.dropdown')" :key="el.link">
          <a
            v-if="el.external_link"
            :href="el.external_link"
            target="_blank"
          >
            <div
              class="relative cursor-pointer px-6 py-3 pr-40 text-sm font-medium transition-all hover:bg-yellow-6 hover:font-bold hover:text-grey-2"
              :class="
                (el.matches && el.matches.includes(currentRoute)) || el.link === currentRoute
                  ? 'bg-yellow-6 font-bold text-grey-2'
                  : 'text-grey-3'
              "
              @click="opened = false"
            >
              <div class="flex">
                <img
                  v-if="el.link"
                  :src="getNavigationImgUrl(el.link)"
                  alt=""
                  class="mr-24"
                />
                <div
                  class="absolute left-14 top-1/2 -translate-y-1/2 transform"
                >
                  {{ el.name }}
                </div>
              </div>
            </div>
          </a>
          <router-link
            v-else
            :to="{ name: el.active === 'false' ? 'dashboard' : el.link }"
          >
            <div
              :id="'gp-link-app-' + el.link + '-1'"
              class="relative cursor-pointer px-6 py-3 pr-40 text-sm font-medium text-grey-3 transition-all hover:bg-yellow-6 hover:font-bold hover:text-grey-2"
              :class="{
                'cursor-not-allowed opacity-50':
                  !isKycRegular && (el.link === 'giftcards' || el.link === 'account-details'),
                'bg-yellow-6 font-bold text-grey-2':
                  (el.matches && el.matches.includes(currentRoute)) || el.link === currentRoute,
              }"
              @click="opened = false"
            >
              <div class="flex">
                <img
                  v-if="el.link"
                  :id="'gp-link-app-' + el.link + '-image-1'"
                  :src="getNavigationImgUrl(el.link)"
                  alt=""
                  class="mr-24"
                />
                <div
                  :id="'gp-link-app-' + el.link + '-text-1'"
                  class="absolute left-14 top-1/2 -translate-y-1/2 transform"
                >
                  {{ el.name }}
                </div>
              </div>
            </div>
          </router-link>
        </span>
        <div
          class="mt-1 flex cursor-pointer border-t px-6 py-5 pr-24 text-sm font-medium text-grey-4 transition-all hover:font-bold hover:text-grey-2"
          @click="logout"
        >
          <img
            src="@/assets/svg/navigation/logout.svg"
            alt=""
            class="mr-4"
          />
          {{ $t('navigation.logout') }}
        </div>
      </div>
    </div>
    <div class="block lg:hidden">
      <div
        class="fixed bottom-0 z-50 -mb-1 flex w-full items-center justify-evenly bg-white pt-4"
        style="
          padding-bottom: calc(var(--sab) + 16px);
          box-shadow: 0 -20px 30px -16px rgba(39, 52, 65, 0.1);
        "
      >
        <div
          class="absolute top-0 h-1 w-12 bg-orange-2 transition-all"
          :style="'left:' + left + 'px'"
        />

        <div v-for="el in mobileNavOptions" :id="el.link + '-mobile'" :key="el.link" class="w-12">
          <router-link :to="'/' + (el.route ?? el.link)">
            <img v-if="el.link" :src="getMobileNavigationImgUrl(el)" alt="" class="mx-auto w-5" />
            <div
              class="mt-1 text-grey-1"
              :class="{
                'opacity-40': !(
                  (el.matches && el.matches.includes(currentRoute)) ||
                  el.link === currentRoute
                ),
              }"
              style="font-size: 0.625rem"
            >
              {{ el.name }}
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { VueCookieNext } from 'vue-cookie-next'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

const clickoutside = {
  beforeMount: (el, binding) => {
    el.clickOutsideEvent = (event) => {
      const navbardrop = document.getElementById('navbar-drop')

      // here I check that click was outside the el and his children
      if (!el.contains(event.target) && !navbardrop.contains(event.target)) {
        // and if it did, call method provided in attribute value
        binding.instance.opened = false
      }
    }
    document.addEventListener('click', el.clickOutsideEvent)
  },

  unmounted: (el) => {
    document.removeEventListener('click', el.clickOutsideEvent)
  },
}

export default {
  directives: {
    clickoutside,
  },
  setup() {
    const opened = ref(false)
    const route = useRoute()
    const store = useStore()
    const scroll = ref(false)
    const router = useRouter()
    const isIos = ref(false)
    const i18n = useI18n({ useScope: 'global' })
    const mobileNavOptions = ref([])
    const currentRoute = computed(() => {
      return route.name
    })

    const left = computed(() => {
      return store.state.general.leftNav
    })

    function getNavigationImgUrl(name) {
      return require(`/src/assets/svg/navigation/${name}.svg`)
    }

    function getMobileNavigationImgUrl(el) {
      const selected =
        (el.matches && el.matches.includes(currentRoute.value)) || el.link === currentRoute.value
          ? '-selected'
          : ''
      const icon = el.mobileIcon ?? el.link
      return require(`/src/assets/svg/navigation/mobile/${icon}${selected}.svg`)
    }

    window.gonative_device_info = function (deviceInfo) {
      if (deviceInfo) {
        isIos.value = deviceInfo.platform === 'ios'
      }
    }

    const profile = computed(() => {
      return store.getters.getProfile()
    })

    const isKycRegular = computed(() => {
      return profile.value?.kyc_level === 'regular'
    })

    const initials = computed(() => {
      const first = profile.value.name ? profile.value.name[0] : ''
      let second = profile.value.surname ? profile.value.surname.split(' ') : ''
      if (second) second = second.length > 1 ? second[second.length - 1] : second[0]
      return first + second[0]
    })


    onMounted(() => {
      document.addEventListener('scroll', () => {
        scroll.value = document.documentElement.scrollTop !== 0
      })

      const navbarOptions = buildNav()
      store.dispatch('setNavbarOptions', navbarOptions)
      mobileNavOptions.value = navbarOptions
    })
    onUnmounted(() => {
      document.removeEventListener('scroll', () => {
        scroll.value = document.documentElement.scrollTop !== 0
      })
    })

    const isPromoter = computed(() => {
      if (profile.value) 
        return profile.value.promoter_id
      return false
    })

    const navigationLinksDesktop = computed(() => {
      return buildNav().filter((option) => option.link !== 'loans' && option.link !== 'settings')
    })

    function logout() {
      store.dispatch('setLoading', true)
      store
        .dispatch('logout', VueCookieNext.getCookie('token'))
        .then(() => {
          store.dispatch('resetToasts')
          window.localStorage.setItem('clicked_logout', true)
          store.dispatch('setLoading', false)
          router.push({ name: 'login' })
        })
        .catch(() => {
          store.dispatch('setLoading', false)
          router.push({ name: 'login' })
        })
    }

    const buildNav = () => {
      // options for items in the mobile bottom nav
      // scope defines what type of account can see the item
      const options = [
        {
          icon: 'fas fa-house-chimney',
          link: 'dashboard',
          matches: ['transactions', 'contracts', 'financial-area'],
          name: i18n.t('navigation.mobile_nav_options.home'),
          scope: 'all',
        },
        {
          icon: 'fas fa-seedling',
          link: 'projects',
          matches: ['loans', 'loan'],
          name: i18n.t('navigation.mobile_nav_options.invest'),
          scope: 'particular,company',
        },
        {
          link: 'campaigns',
          matches: ['campaigns'],
          name: i18n.t('navigation.mobile_nav_options.campaigns_promoter'),
          scope: 'promoter',
        },
        {
          link: 'loans',
          matches: ['loans', 'loan'],
          name: i18n.t('navigation.mobile_nav_options.loans'),
          scope: 'promoter',
        },
        {
          icon: 'fas fa-seedling',
          link: 'impact',
          name: i18n.t('navigation.mobile_nav_options.impact'),
          scope: 'all',
        },
        {
          icon: 'fas fa-user',
          link: 'settings',
          mobileIcon: 'settings-nav',
          matches: ['settings', 'invite'],
          name: i18n.t('navigation.mobile_nav_options.settings'),
          scope: 'all',
        },
      ]

      const scopesToCheck = isPromoter.value
        ? ['promoter', 'all']
        : ['all', 'particular', 'company']
      // filter my options and if the option contains one of the scopes we include it in the navbar
      const mobileNav = options.filter((option) => {
        const scopes = option.scope.split(',')
        return scopesToCheck.some((scope) => scopes.includes(scope))
      })

      return mobileNav
    }

    return {
      profile,
      opened,
      currentRoute,
      logout,
      isPromoter,
      navigationLinksDesktop,
      left,
      scroll,
      initials,
      isKycRegular,
      mobileNavOptions,
      getNavigationImgUrl,
      getMobileNavigationImgUrl,
    }
  },
}
</script>

<style lang="css" scoped>
.animate-navbar {
  animation: appear-navbar ease-out 0.3s forwards;
}
@keyframes appear-navbar {
  0% {
    transform: translateY(-200%);
  }
  100% {
    transform: translateY(0%);
  }
}

.nav-link:hover {
  text-shadow:
    0 0 0.65px #4f5963,
    0 0 0.65px #4f5963;
}

.bg-navbar {
  background: #f4f6f2;
}
</style>
